<template>
	<nav class="float-left rtl" v-if="pages > 1 " style='overflow-x: scroll; overflow-y: clip;'>
		<ul class="pagination" v-if="(10+parseInt(page))<=pages">
			<li class="page-item pointer" :class="{'d-none': page==1}">
				<a style="padding: 10px !important; height: 45px; display: flex; align-items: center;" class="page-link" aria-label="Previous" @click="setPage(parseInt(page)-1);">
					<span aria-hidden="true">
						<img
							style="transform: rotate(180deg);"
							:src="require('../../assets/img/Arrow_Left2.svg')"
						/>
					</span>
				</a>
			</li>
			<li class="page-item pointer" :class="{'active ': j==page}" v-for="(j) in (10+parseInt(page))" :key="j">
				<a style="padding: 0 10px !important; height: 45px; display: flex;align-items: center;" class="page-link yekan btn" :class="{'btn-succes': j==page}" @click="setPage(j)">{{j}}</a>
			</li>
			<li class="pr-3 pl-3 page-item pointer" style="display: flex; align-items: center;" v-if="(10+parseInt(page))<=pages">
				...
			</li>
			<li class="page-item pointer" :class="{'d-none': page==pages}">
				<a style="padding: 10px !important; height: 45px; display: flex; align-items: center;" class="page-link" aria-label="Next" @click="setPage(parseInt(page)+1);">
					<span aria-hidden="true">
						<img
							:src="require('../../assets/img/Arrow_Left2.svg')"
						/>
					</span>
				</a>
			</li>
		</ul>
		<ul class="pagination" v-else>
			<li class="page-item pointer" :class="{'d-none': page==1}">
				<a style="padding: 10px !important; height: 45px; display: flex; align-items: center;"  class="page-link" aria-label="Previous" @click="setPage(parseInt(page)-1);">
					<span aria-hidden="true">
						<img
							style="transform: rotate(180deg);"
							:src="require('../../assets/img/Arrow_Left2.svg')"
						/>
					</span>
				</a>
			</li>
			<li class="page-item pointer" :class="{'active ': j==page}" v-for="(j) in pages" :key="j">
				<a style="padding: 0 10px !important; height: 45px; display: flex;align-items: center;" class="page-link yekan btn" :class="{'btn-succes': j==page}" @click="setPage(j)">{{j}}</a>
			</li>
			<li class="page-item pointer" :class="{'d-none': page==pages}">
				<a style="padding: 10px !important; height: 45px; display: flex; align-items: center;" class="page-link" aria-label="Next" @click="setPage(parseInt(page)+1);">
					<span aria-hidden="true">
						<img
							:src="require('../../assets/img/Arrow_Left2.svg')"
						/>
					</span>
				</a>
			</li>
		</ul>
	</nav>
</template>

<script>
	export default {
		name: 'PageNavigation',
		data(){
			return {
			}
		},
		props: ['pages', 'page'],
		methods:{
			setPage: function(j){
				let query = { page: j.toString() };
				for (let q in this.$route.query) {
					if (q != 'page') {
						query[q] = this.$route.query[q];
					}
				}
				this.$router.push({query: query});			
				this.$emit('setPage', j);
			}
		},
		mounted(){
		},
	}
</script>

<style scope>
.page-item.active .page-link, .page-link:hover{
	background-color: #1b60c6 !important;
    border-color: #1b60c6 !important;
}
</style>
